// @flow
/** @jsx jsx
 * @jsxFrag React.Fragment
 */
import jsx from '@emotion/jsx'
import * as React from 'react'
import { Route } from 'react-router-dom'
import html2canvas from 'html2canvas'

const cache = {}

function importAll(r) {
  r.keys().forEach(key => (cache[key] = r(key)))
}

// $FlowFixMe
importAll(require.context('./assets/', true, /\.png$/))

const letters = 'abcdefghijklmnopqrstuvwxyz'.split('')

const characters: { [string]: Array<{ name: string, src: string }> } = {}

letters.forEach(letter => {
  characters[letter] = []
})

const namePattern = /\.\/\w-(.+)\.png/

Object.keys(cache).forEach(name => {
  const letter = name[2]
  const match = name.match(namePattern)
  if (!match) {
    throw Error('There was a problem parsing the image filename')
  }
  characters[letter].push({
    name: match[1],
    src: cache[name]
  })
})

class NoUpdate extends React.Component<{ innerRef: Function }> {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return <div ref={this.props.innerRef} />
  }
}

const Characters = ({ text }: { text: string }) => {
  const usedChars = {}

  return (
    <div css={{ padding: 6, backgroundColor: 'transparent' }}>
      {text
        .toLowerCase()
        .split('')
        .map((letter, i) => {
          if (characters[letter] === undefined) {
            return (
              <span
                key={i}
                css={{
                  fontSize: 50,
                  paddingLeft: 10,
                  paddingRight: 10
                }}
              >
                {text[i]}
              </span>
            )
          }

          let charIndex
          if (usedChars[letter] === undefined) {
            charIndex = 0
            usedChars[letter] = 0
          } else if (usedChars[letter] === characters[letter].length - 1) {
            charIndex = usedChars[letter] = 0
          } else {
            charIndex = usedChars[letter] = usedChars[letter] + 1
          }
          return (
            <div
              key={i}
              css={{
                display: 'inline-flex',
                flexDirection: 'column',
                paddingBottom: 6,
                paddingTop: 6,
                width: 75
              }}
            >
              <img
                height={60}
                width={60}
                css={{
                  display: 'inline-block',
                  height: 60,
                  width: 60
                }}
                src={characters[letter][charIndex].src}
              />
              <span
                css={{
                  padding: 4,
                  marginBottom: -8
                }}
              >
                {characters[letter][charIndex].name}
              </span>
            </div>
          )
        })}
    </div>
  )
}

export default class App extends React.Component<{}> {
  thing: ?HTMLDivElement
  canvasContainerNode: ?HTMLDivElement
  render() {
    return (
      <>
        <div css={{ textAlign: 'center' }}>
          <h1
            css={{
              '@media print': {
                display: 'none'
              }
            }}
          >
            Mathonyms
          </h1>
          <Route
            path="/:name?"
            render={({ match, history, location }) => {
              const usedChars = {}
              const decoded = decodeURIComponent(match.params.name || '')
              return (
                <>
                  <div
                    css={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <input
                      autoFocus
                      css={{
                        '@media print': {
                          display: 'none'
                        },
                        display: 'block'
                      }}
                      onChange={e => {
                        history.replace(
                          `/${encodeURIComponent(
                            e.target.value
                          )}${location.search || ''}`
                        )
                      }}
                      placeholder="Enter text"
                      value={decoded}
                    />
                    <button
                      css={{ margin: 8 }}
                      onClick={async () => {
                        if (this.thing) {
                          const canvas = await html2canvas(this.thing)
                          const link = document.createElement('a')
                          link.href = canvas.toDataURL('image/png')
                          link.download = `mathonym.png`
                          link.dispatchEvent(new MouseEvent('click'))
                        }
                      }}
                    >
                      Save Image
                    </button>
                  </div>
                  <div
                    css={{
                      position: 'fixed',
                      top: -5000,
                      left: -5000
                    }}
                  >
                    <div
                      ref={node => {
                        this.thing = node
                      }}
                    >
                      <Characters text={decoded} />
                    </div>
                  </div>

                  <Characters text={decoded} />
                </>
              )
            }}
          />
        </div>
        {document.location.search !== '?dom' && (
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'auto'
            }}
          >
            <NoUpdate
              innerRef={node => {
                this.canvasContainerNode = node
              }}
            />
          </div>
        )}
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js